import {
    AfterViewInit,
    Component,
    Input,
    ViewEncapsulation
} from '@angular/core';
import { OrderModel } from '../../shared/models/payment/order/order.model';
import {
    Content,
    FacebookService
} from '../../shared/services/facebook.service';
import {
    GoogleGtagService,
    PurchaseItem
} from '../../shared/services/google.gtag.service';
import { GooglePatternNumberFormatter } from '../../shared/services/google-pattern-number-formatter';

@Component({
    selector: 'completed-order',
    templateUrl: './completed.order.component.html',
    styleUrls: ['../completed.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CompletedOrderComponent implements AfterViewInit {
    @Input('order') order: OrderModel;
    @Input('storeConfigurations') storeConfigurations = [];
    @Input('isHugeOrder') isHugeOrder = false;

    constructor(
        protected facebookService: FacebookService,
        protected googleGtagService: GoogleGtagService,
        protected googlePatternNumberFormatter: GooglePatternNumberFormatter
    ) { }

    ngAfterViewInit () {
        this.publishPurchaseValues();

        this.facebookService.configure(this.storeConfigurations);
        this.facebookService.trackPageView();
        this.facebookService.trackConversion(
            this.order.total,
            this.parseContentIds(),
            this.facebookService.CONTENT_TYPE_PRODUCT,
            this.parseContentNames(),
            this.parseContents(),
            this.parseNumItems()
        );

        const hasGoogleConversionId = this.storeConfigurations['google-conversion-id'] !== undefined
            && this.storeConfigurations['google-conversion-id'] !== null;
        
        const googleAnalyticsAccount = (this.storeConfigurations['google-analytics-account'] !== undefined
            && this.storeConfigurations['google-analytics-account'] !== null) ? this.storeConfigurations['google-analytics-account'] : null;
        
        this.googleGtagService
            .setHasGoogleConversionId(hasGoogleConversionId)
            .setGoogleConversionAccount(googleAnalyticsAccount)
            .purchase(
                `${this.order.id}`,
                this.order.subtotal,
                this.order.other_costs,
                this.order.freight,
                this.buildItems()
            );
    }

    private parseContentIds(): Array<number> {
        const ids = [];
        for (let item of this.order.items) {
            ids.push(item.item.id);
        }

        return ids;
    }
    private parseContentNames(): string {
        const names = [];
        for (let item of this.order.items) {
            names.push(item.item.name);
        }
        return names.join(', ');
    }
    private parseContents(): Array<Content> {
        const contents: Array<Content> = [];
        for (let item of this.order.items) {
            contents.push({
                'id': `${item.item.id}`,
                'quantity': parseInt(item.quantity, 10)
            });
        }

        return contents;
    }
    private parseNumItems(): number {
        return this.order
            .items
            .reduce((sum, item) => sum += parseInt(item.quantity, 10), 0);
    }

    public hasDeliveryAddress() {
        return this.order.deliveries !== undefined
            && this.order.deliveries.address !== undefined;
    }

    private buildItems(): Array<PurchaseItem> {
        return this.order.items.map(orderItem => {
            return {
                id: `${orderItem.item.id}`,
                name: orderItem.item.name,
                category: this.buildCategory(orderItem.item, orderItem.item.name),
                quantity: parseFloat(orderItem.quantity),
                price: this.googlePatternNumberFormatter.transform(orderItem.unit_price),
                unit_price: this.googlePatternNumberFormatter.transform(orderItem.unit_price)
            };
        });
    }
    /**
     * Define category value or return default value if empty.
     **/
    private buildCategory(item, defaultCategory) {
        let categoryStr = item.categories.map(category => category.name).join(', ');
        if (categoryStr === '') {
            categoryStr = defaultCategory;
        }

        return categoryStr;
    }

    /**
     * Publishes a curated order/client/installment snapshot to
     * window.finished_page_values_modifier, so an external script can read
     * them without touching this app's code.
     */
    private publishPurchaseValues(): void {
        const w = window as any;

        w.finished_page_values_modifier = {
            type: 'order',
            order: {
                id: this.order.id,
                discount: this.order.discount,
                freight: this.order.freight,
                subtotal: this.order.subtotal,
                total: this.order.total
            },
            client: this.order.client,
            installment: (this.order.payment_card && this.order.payment_card.installments) || 1
        };
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/completed/order/completed.order.component.ts